<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-row class="mt-4">
      <v-col sm="12">
        <v-label :disabled="!enabled">
          {{ label }}
          <cp-help :i18n="help" />
        </v-label>
      </v-col>
      <v-col sm="8" xl="8">
        <v-slider
          class="mt-0"
          ticks
          thumb-label
          :min="min"
          :max="max"
          v-model="timeout"
          :disabled="!enabled"
        ></v-slider>
      </v-col>
      <v-col sm="1">
        <div>
          <v-text-field
            class="mt-0 pt-0"
            v-model="timeout"
            type="number"
            :disabled="!enabled"
            style="min-width: 80px"
            :rules="rules"
          >
            <template v-slot:append>
              {{ $t('settings.fme.seconds') }}
            </template>
          </v-text-field>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: 'settings-followme-tout',
  data () {
    return {
      min: 0,
      max: 100,
      timeout: 0,
      valid: true,
      rules: [
        v => (v !== undefined && v >= this.min) || this.$t('settings.fme.errTimeoutTooSmall', { timeout: v }),
        v => (v !== undefined && v <= this.max) || this.$t('settings.fme.errTimeoutTooBig', { timeout: v })
      ]
    }
  },
  props: {
    enabled: {
      type: Boolean,
      required: true,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    tout: {
      type: Number,
      required: true
    },
    help: {
      type: String
    }
  },
  mounted () {
    this.timeout = this.tout
  },
  watch: {
    timeout: function (val) {
      this.$emit('change', val)
    },
    tout: function (val) {
      this.timeout = val
    },
    valid (newValue, oldValue) {
      this.$emit('timeout-valid', newValue)
    }
  }
}
</script>

<style>
</style>
